<template>
  <div class="content-container" style="height: auto">
    <div class="content-box">
      <div
        ref="agGridWrapper"
        v-loading="tableLoading"
        class="section-box outline"
      >
        <search-comp @onSearch="getList" @onReset="onReset">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Đại lý</div>
                    <div class="child-w-80">
                      <!-- v-model="searchParams.roomNumber" -->
                      <select-with-search-table
                        style="width: 100%"
                        :rows="agentOptions"
                        :columns="columnsAgent"
                        index-field="id"
                        :selected-index-field-value="searchParams.agentIdList"
                        :value="searchParams.agentIdList"
                        @selectionChanged="onSelectRowAgent"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.name }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.hotelIdList"
                        collapse-tags
                        multiple
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRange"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">{{
                this.$t('route.revenueByAgencyReport')
              }}</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div class="grid-scroll mt-10" style="height: 400px">
            <GridVx
              ref="agGrid"
              style="height: 400px"
              :columns="columns"
              :rows="rows"
              :dom-layout="'scroll'"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              class="agGrid"
              :auto-size-cell="true"
              @selectionChanged="onSelectRow"
            />
            <!-- aggridReport -->
          </div>
          <div class="button-containers">
            <button
              class="btn primary small"
              :disabled="!selectedRow"
              @click="fnOpenAgentDetail"
            >
              Xem chi tiết
            </button>
          </div>
        </div>
      </div>
      <div v-loading="pieChartLoading" class="section-box outline">
        <search-comp @onSearch="getListPieChart" @onReset="onResetPieChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRangePieChart"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionPieChart"
                    autoresize
                    @click="handleClickPieChart"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-loading="lineChartLoading" class="section-box outline">
        <search-comp @onSearch="getListLineChart" @onReset="onResetLineChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Đại lý</div>
                    <div class="child-w-80">
                      <!-- v-model="searchParams.roomNumber" -->
                      <select-with-search-table
                        style="width: 100%"
                        :rows="agentOptions"
                        :columns="columnsAgent"
                        :multiple="true"
                        index-field="id"
                        :dropdown-width="400"
                        :selected-index-field-value="
                          searchParamsLine.agentIdList
                        "
                        :value="searchParamsLine.agentIdList"
                        @selectionChanged="onSelectRowAgentLineChart"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <!-- {{ selectedData?.name }} -->
                          <span v-if="selectedData?.length">
                            {{ selectedData.map(item => item.name).join(', ') }}
                          </span>
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <!-- :date-data="agentItem.representative_card_date" -->
                      <!-- v-model="agentItem.representative_card_date" -->
                      <!-- @changeCalendar="onChangeDate2" -->
                      <CalendarRange
                        v-model="datetimeRangeLineChart"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionLineChart"
                    autoresize
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-loading="barChartLoading" class="section-box outline">
        <search-comp @onSearch="getListBarChart" @onReset="onResetBarChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Tháng</div>
                    <div class="child-w-80">
                      <el-date-picker
                        v-model="datetimeRangeBarChart"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="Vui lòng chọn tháng, năm"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParamsBar.hotelIdList"
                        collapse-tags
                        multiple
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionHistogramChart"
                    autoresize
                    @click="handleClickBarChart"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>STT: Số thứ tự</li>
            <li>
              Nhóm nguồn: hiển thị Danh sách tên nhóm nguồn (Cấu hình> Kế toán >
              Nhóm nguồn
            </li>
            <li>Người lớn: Tông số lượng người lớn trong Nhóm nguồn</li>
            <li>Trẻ em: Tổng số lượng trẻ em trong Nhóm nguồn</li>
            <li>Số lượng phòng: Số lượng phòng đặt của nhóm nguồn</li>
            <li>
              Số đêm : Hiển thị Số đêm lưu trú của đặt phòng thuộc thời gian tìm
              kiếm của nhóm nguồn
            </li>
            <li>Doanh thu: Doanh thu phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getAllHotel } from '@/api/hotel'
import { getAgent } from '@/api/reception/common.js'
import {
  getAgentRevenueApi,
  getAgentRevenueApiExcel,
  getAgentRevenueLineChartApi,
  getAgentRevenueBarChartApi
} from '@/api/report_service/report_b'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'

import { PieChart, BarChart, LineChart } from 'echarts/charts'
import { use } from 'echarts/core'

use([BarChart, PieChart, LineChart])
import InfoBtn from './components/InfoBtn.vue'
import { color } from '@/utils/color'

const getOptionHistogramChartDefault = () => ({
  title: {
    text: 'Doanh thu của từng công ty, đại lý'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    formatter: params => {
      var axisLabel = params[0].axisValue
      var tooltipContent = ''
      var total = 0
      params.map(item => {
        if (item.value !== null && item.value !== undefined) {
          total += item.value
        }
      })
      params.forEach(item => {
        if (
          item.value !== 0 &&
          item.value !== null &&
          item.value !== undefined
        ) {
          const colorBlock = item.marker
          const percent = ((item.value / total) * 100).toFixed(2)
          tooltipContent += `<div style="display: flex; flex-direction: row;align-items: center; justify-content: space-between; gap: 8px"><span>${colorBlock} ${
            item.seriesName
          }</span> ${item.value.toLocaleString('en-US')} VND(${percent}%)</div>`
        }
      })
      tooltipContent =
        `<span style="font-weight: 600">${axisLabel}</span><br><span style="font-weight: 600">Tổng doanh thu: ${total.toLocaleString(
          'en-US'
        )} VND</span><br>` + tooltipContent
      return tooltipContent
    },
    enterable: true
  },
  legend: {
    orient: 'horizontal',
    type: 'scroll',
    bottom: 0
  },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: 60,
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisTick: {
        alignWithLabel: true
      }
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})
const getOptionPieChartDefault = () => ({
  title: {
    text: 'Tỷ lệ doanh thu của từng Công ty, Đại lý'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'item',
    confine: true,
    extraCssText: 'overflow: scroll;text-wrap: wrap;',
    valueFormatter: value => value.toFixed(2) + '%'
  },
  legend: {
    orient: 'vertical',
    type: 'scroll',
    textStyle: {
      width: 300,
      overflow: 'break'
    },
    top: 50,
    left: '5%'
    // bottom: 20
  },
  series: [
    {
      name: 'Doanh thu',
      type: 'pie',
      avoidLabelOverlap: true,
      left: '40%',
      width: '60%',
      radius: '85%',
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
})
const getOptionLineChartDefault = () => ({
  // color: ['#5470C6', '#EE6666', '#ccc'],
  title: {
    text: 'Tăng trưởng của từng Công ty, đại lý'
    // left: 'center'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    valueFormatter: value =>
      value !== null ? value.toLocaleString('en-US') + ' VND' : null,
    enterable: true
  },
  legend: {
    type: 'scroll',
    bottom: 0
  },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: 100
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false
        // lineStyle: {
        //   color: '#5470C6'
        // }
      },
      // axisPointer: {
      //   label: {
      //     formatter: function (params) {
      //       return (
      //         'Doanh thu ' +
      //         params.value +
      //         (params.seriesData.length ? '：' + params.seriesData[0].data : '')
      //       )
      //     }
      //   }
      // },
      // prettier-ignore
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})

export default {
  components: {
    CalendarRange,
    InfoBtn,
    SelectWithSearchTable
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },

      tableLoading: false,
      pieChartLoading: false,
      lineChartLoading: false,
      barChartLoading: false,

      dialogFormVisible: false,
      hotelList: [],
      agentOptions: [],
      columnsAgent: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          minWidth: 80
        },
        {
          headerName: 'Tên công ty, đại lý du lịch',
          field: 'name',
          tooltipField: 'name',
          flex: 1,
          minWidth: 200
        }
      ],
      selectedRow: null,
      searchParams: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        agentIdList: [],
        hotelIdList: []
      },
      searchParamsDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        roomLevel: [],
        hotelIdList: []
      },
      optionPieChart: getOptionPieChartDefault(),

      optionLineChart: getOptionLineChartDefault(),
      optionHistogramChart: getOptionHistogramChartDefault(),
      columns: [
        {
          headerName: this.$t('grid.column.order'),
          field: 'no',
          tooltipField: 'no',
          minWidth: 70,
          maxWidth: 80,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.companyOrAgency'),
          field: 'agent_nm',
          headerTooltip: this.$t('grid.column.companyOrAgency'),
          tooltipField: 'agent_nm',
          // width: 100,
          minWidth: 100,
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.adult'),
          field: 'num_of_adult',
          tooltipField: 'num_of_adult',
          minWidth: 100,
          maxWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.child'),
          field: 'num_of_child',
          tooltipField: 'num_of_child',
          minWidth: 100,
          maxWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomNum'),
          field: 'num_of_room',
          headerTooltip: this.$t('grid.column.roomNum'),
          tooltipField: 'num_of_room',
          minWidth: 100,
          maxWidth: 120,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.numNight'),
          field: 'num_of_night',
          headerTooltip: this.$t('grid.column.numNight'),
          tooltipField: 'num_of_night',
          minWidth: 100,
          maxWidth: 120,
          sortable: false
        },

        {
          headerName: this.$t('grid.column.revenue'),
          field: 'revenue',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right',
          minWidth: 100,
          // maxWidth: 250,
          flex: 1,
          // tooltipField: 'revenue',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.total'),
          field: 'total',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right',
          // tooltipField: 'total',
          minWidth: 100,
          flex: 1,
          // maxWidth: 250,
          sortable: false
        }
      ],
      rows: [],

      // filter pie chart
      searchParamsPie: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD')
      },
      searchParamsPieDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD')
      },

      // filter line chart
      searchParamsLine: {
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        agentIdList: []
      },
      searchParamsLineDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        agentIdList: []
      },

      // filter bar chart
      searchParamsBar: {
        // dateTo: this.$moment().format('YYYY-MM-DD'),
        // dateFrom: this.$moment().format('YYYY-MM-DD')
        year: this.$moment().year(),
        month: this.$moment().month() + 1,
        hotelIdList: []
      },
      searchParamsBarDefault: {
        // dateTo: this.$moment().format('YYYY-MM-DD'),
        // dateFrom: this.$moment().format('YYYY-MM-DD')
        year: this.$moment().year(),
        month: this.$moment().month() + 1,
        hotelIdList: []
      }
    }
  },
  computed: {
    datetimeRange: {
      get() {
        return {
          start: this.searchParams.dateFrom,
          end: this.searchParams.dateTo
        }
      },
      set(val) {
        this.searchParams.dateFrom = val.start
        this.searchParams.dateTo = val.end
      }
    },
    datetimeRangePieChart: {
      get() {
        return {
          start: this.searchParamsPie.dateFrom,
          end: this.searchParamsPie.dateTo
        }
      },
      set(val) {
        this.searchParamsPie.dateFrom = val.start
        this.searchParamsPie.dateTo = val.end
      }
    },
    datetimeRangeLineChart: {
      get() {
        return {
          start: this.searchParamsLine.dateFrom,
          end: this.searchParamsLine.dateTo
        }
      },
      set(val) {
        this.searchParamsLine.dateFrom = val.start
        this.searchParamsLine.dateTo = val.end
      }
    },
    datetimeRangeBarChart: {
      get() {
        if (
          this.searchParamsBar.year !== null &&
          this.searchParamsBar.month !== null
        ) {
          return this.$moment(
            this.searchParamsBar.year + '-' + this.searchParamsBar.month
          ).format('YYYY-MM')
        }
        return null
      },
      set(val) {
        if (val === null) {
          this.searchParamsBar.year = null
          this.searchParamsBar.month = null
          return
        }
        this.searchParamsBar.year = this.$moment(val, 'YYYY-MM').year()
        this.searchParamsBar.month = this.$moment(val, 'YYYY-MM').month() + 1
      }
    }
  },
  async created() {
    await this.getListHotel()

    await this.getListAgent()

    await this.getList()
    await this.getListPieChart()
    this.getListLineChart()
    this.getListBarChart()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd === 'excel') {
        getAgentRevenueApiExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'doanh_thu_theo_dai_ly_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30

      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getListAgent() {
      var data = await getAgent()
      // getAgent
      this.agentOptions = data.data
    },
    onSelectRowAgent(val) {
      this.searchParams.agentIdList = val.id
    },
    onSelectRowAgentLineChart(val) {
      this.searchParamsLine.agentIdList = val.map(item => item.id) ?? null
    },
    onSelectRow(selected) {
      console.log('ledoan', selected)
      this.selectedRow = selected[0]
    },
    fnOpenAgentDetail() {
      console.log('ledoan', this.selectedRow)
      this.$router.push({
        path: '/report/director_report/analysis_report/agency_detail_report',
        query: {
          agentId: this.selectedRow?.agent_id,
          dateFrom: this.searchParams.dateFrom,
          dateTo: this.searchParams.dateTo
        }
      })
    },
    async getList() {
      if (
        this.searchParams.dateFrom === null ||
        this.searchParams.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.tableLoading = true
      // reset selected Row
      this.selectedRow = null
      this.rows = []
      await getAgentRevenueApi(this.searchParams)
        .then(res => {
          var data = res.data
          this.rows = data
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    async onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      await this.getList()
    },
    async getListPieChart() {
      if (
        this.searchParamsPie.dateFrom === null ||
        this.searchParamsPie.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.pieChartLoading = true
      this.optionPieChart = getOptionPieChartDefault()
      // this.rows = []
      await getAgentRevenueApi(this.searchParamsPie)
        .then(res => {
          var data = res.data
          const sortList = res.data.sort((a, b) => b?.revenue - a?.revenue)
          const top9List = sortList.slice(0, 9)
          const otherList = sortList.slice(9)
          const otherListDebtSum = otherList.reduce((acc, item) => {
            return item?.revenue + acc
          }, 0)
          if (otherListDebtSum > 0) {
            top9List.push({
              revenue: otherListDebtSum,
              agent_nm: 'Others'
            })
          }
          var total = 0
          data.map(item => {
            total = total + item.revenue
          })
          this.optionPieChart.series[0].data = top9List.map(item => {
            return {
              value: (item.revenue / total).toFixed(4) * 100,
              // value: item.revenue,
              name: item.agent_nm,
              id: item?.agent_id
            }
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.pieChartLoading = false
        })
    },
    async onResetPieChart() {
      this.searchParamsPie = Object.assign({}, this.searchParamsPieDefault)
      await this.getListPieChart()
    },
    async getListLineChart() {
      this.optionLineChart = getOptionLineChartDefault()
      // this.rows = []
      if (
        this.searchParamsLine.dateFrom !== null &&
        this.searchParamsLine.dateTo !== null
      ) {
        if (
          this.$moment(this.searchParamsLine.dateTo).diff(
            this.$moment(this.searchParamsLine.dateFrom),
            'days'
          ) < 2
        ) {
          this.$message({
            type: 'error',
            message: 'Khoảng thời gian có độ dài tối thiểu 3 ngày.'
          })
          return
        }
      } else {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.lineChartLoading = true
      await getAgentRevenueLineChartApi(this.searchParamsLine)
        .then(res => {
          var data = res.map
          this.optionLineChart.xAxis[0].data = data.day
          for (var i = 0; i < data.agent.length; i++) {
            this.optionLineChart.series[i] = {
              name: data.agent[i].agent_nm,
              id: data.agent[i].agent_id,
              type: 'line',
              xAxisIndex: 0,
              smooth: true,
              emphasis: {
                focus: 'series'
              },
              data: data.agent[i].increaseRevenueReportByAgentList
            }
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.lineChartLoading = false
        })
    },
    async onResetLineChart() {
      this.searchParamsLine = Object.assign({}, this.searchParamsLineDefault)
      await this.getListLineChart()
    },
    async getListBarChart() {
      if (
        this.searchParamsBar.month === null ||
        this.searchParamsBar.year === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng chọn tháng.'
        })
        return
      }
      this.barChartLoading = true
      this.optionHistogramChart = getOptionHistogramChartDefault()
      // this.rows = []
      await getAgentRevenueBarChartApi(this.searchParamsBar)
        .then(res => {
          var data = res.data
          for (var i = 0; i < data.length; i++) {
            this.optionHistogramChart.xAxis[0].data[i] = data[i].date
            var top_max =
              data[i].agent_revenue.length > 9
                ? 9
                : data[i].agent_revenue.length
            for (var j = 0; j < top_max; j++) {
              if (
                !this.optionHistogramChart.series.some(item => {
                  return item.id === data[i].agent_revenue[j].agent_id
                })
              ) {
                this.optionHistogramChart.series.push({
                  name: data[i].agent_revenue[j].agent_nm,
                  id: data[i].agent_revenue[j].agent_id,
                  type: 'bar',
                  stack: 'revenueAgent',
                  label: {
                    show: false
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: data.map(item => {
                    var val = null
                    item.agent_revenue.map((item1, index) => {
                      if (
                        data[i].agent_revenue[j].agent_id === item1.agent_id &&
                        index < 9
                      ) {
                        val = item1.revenue
                      }
                    })
                    return val
                  })
                })
              }
            }
          }
          if (data.length > 9) {
            this.optionHistogramChart.series.push({
              name: 'Còn lại',
              id: -1,
              type: 'bar',
              stack: 'revenueAgent',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: data.map(item => {
                var val = 0
                for (var i = 9; i < item.agent_revenue.length; i++) {
                  val += item.agent_revenue[i].revenue
                }
                return val
              })
            })
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.barChartLoading = false
        })
    },
    async onResetBarChart() {
      this.searchParamsBar = Object.assign({}, this.searchParamsBarDefault)
      await this.getListBarChart()
    },
    async handleClickPieChart(e) {
      // change data and time in table filter
      this.searchParams.dateFrom = this.searchParamsPie.dateFrom
      this.searchParams.dateTo = this.searchParamsPie.dateTo
      this.searchParams.agentIdList = e.data.id
      this.searchParams.hotelIdList = []
      await this.getList()
      this.$refs.agGridWrapper.scrollIntoView({ behavior: 'smooth' })
    },
    async handleClickBarChart(e) {
      // change data and time in table filter
      this.searchParams.dateFrom = e.name
      this.searchParams.dateTo = e.name
      this.searchParams.agentIdList = []
      // this.searchParams.hotelIdList= []
      // this.searchParams.agentIdList = e.data.id
      this.searchParams.hotelIdList = []
      await this.getList()
      this.$refs.agGridWrapper.scrollIntoView({ behavior: 'smooth' })
    },

    // agent detail
    async fnStoreRouteData({ to, from }) {
      const params = {
        ...to.params,
        agentId: this.selectedRow.agent_id
      }
      const routeData = {
        ...to,
        from,
        params
      }
      this.$store.dispatch('app/setRouteData', routeData)
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (to.path === '/gigiday') {
      // waiting
      await this.fnStoreRouteData({ to, from })
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.section-box {
  height: auto !important;
}
</style>
